(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcement-ticker"] && !Shopify.designMode) return;
  try {
    
  class BundleSaveMarquee extends HTMLElement {
    #resizeObserver;
    #frame = 0;
    #track;
    #group;
    #item;

    connectedCallback() {
      this.#track = this.querySelector('[data-marquee-track]');
      this.#group = this.querySelector('[data-marquee-group]');
      this.#item = this.querySelector('[data-marquee-item]');

      if (!this.#track || !this.#group || !this.#item) return;

      this.#resizeObserver = new ResizeObserver(() => this.#queueUpdate());
      this.#resizeObserver.observe(this);
      this.#queueUpdate();
    }

    disconnectedCallback() {
      this.#resizeObserver?.disconnect();
      if (this.#frame) cancelAnimationFrame(this.#frame);
    }

    #queueUpdate = () => {
      if (this.#frame) cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        this.#update();
      });
    };

    #update() {
      const viewportWidth = this.clientWidth;
      this.#item.style.whiteSpace = 'nowrap';
      const itemWidth = this.#item.scrollWidth;
      this.#item.style.removeProperty('white-space');

      if (viewportWidth === 0 || itemWidth === 0) return;

      const gap = Number.parseFloat(getComputedStyle(this).getPropertyValue('--marquee-gap')) || 0;
      this.#track.querySelector('[data-marquee-duplicate]')?.remove();

      Array.from(this.#group.children)
        .slice(1)
        .forEach((item) => item.remove());

      const copyCount = Math.max(1, Math.ceil((viewportWidth + gap) / (itemWidth + gap)));

      for (let index = 1; index < copyCount; index += 1) {
        const copy = this.#item.cloneNode(true);
        copy.removeAttribute('data-marquee-item');
        copy.setAttribute('aria-hidden', 'true');
        this.#group.appendChild(copy);
      }

      const repeatedGroup = this.#group.cloneNode(true);
      repeatedGroup.removeAttribute('data-marquee-group');
      repeatedGroup.dataset.marqueeDuplicate = 'true';
      repeatedGroup.setAttribute('aria-hidden', 'true');
      this.#track.appendChild(repeatedGroup);

      const groupWidth = this.#group.getBoundingClientRect().width;
      this.style.setProperty('--ticker-duration', String(Math.max(20, (groupWidth + gap) / 32)) + 's');
      this.dataset.ready = 'true';
    }
  }

  if (!customElements.get('bundle-save-marquee')) {
    customElements.define('bundle-save-marquee', BundleSaveMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiny-worlds-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tw-product-gallery')) {
    customElements.define('tw-product-gallery', class extends HTMLElement {
      #photos = [];
      #index = 0;
      #interval = null;

      connectedCallback() {
        this.#photos = [...this.querySelectorAll('.tw-collection__photo')];
        if (this.#photos.length < 2) return;
        this.addEventListener('pointerenter', this.#start);
        this.addEventListener('pointerleave', this.#reset);
      }

      disconnectedCallback() {
        this.removeEventListener('pointerenter', this.#start);
        this.removeEventListener('pointerleave', this.#reset);
        this.#stop();
      }

      #start = (event) => {
        if (event.pointerType !== 'mouse' || this.#interval !== null) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.#advance();
        this.#interval = window.setInterval(this.#advance, 1100);
      };

      #reset = () => {
        this.#stop();
        if (this.#index !== 0) this.#show(0);
      };

      #stop() {
        if (this.#interval === null) return;
        window.clearInterval(this.#interval);
        this.#interval = null;
      }

      #advance = () => {
        if (this.#photos.length < 2) return;
        this.#show((this.#index + 1) % this.#photos.length);
      };

      #show(index) {
        const currentPhoto = this.#photos[this.#index];
        currentPhoto?.classList.remove('is-active');
        currentPhoto?.setAttribute('aria-hidden', 'true');

        this.#index = index;
        const nextPhoto = this.#photos[this.#index];
        nextPhoto?.classList.add('is-active');
        nextPhoto?.removeAttribute('aria-hidden');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
